/**
 * Academy view context
 * @readonly
 * @enum {string}
 */
export const academyContext = {
  ADMIN: 'admin',
  USER: 'user',
};

/**
 * Document handling context
 * @readonly
 * @enum {string}
 */
export const documentContext = {
  GLOBAL: 'global',
  SESSION: 'session',
  TRAINING: 'training',
  TRAINING_SITE: 'training_site',
};

/**
 * Document types
 * @readonly
 * @enum {string}
 */
export const documentType = {
  COURSE_MATERIALS: 'COURSE_MATERIALS',
  COVER: 'COVER',
  DOCUMENTATION: 'DOCUMENTATION',
  INVOICE: 'INVOICE',
  OTHER: 'OTHER',
  REPORT: 'REPORT',
  SESSION_AGREEMENT: 'SESSION_AGREEMENT',
  SESSION_PROGRAM: 'SESSION_PROGRAM',
  SESSION_ATTENDANCE: 'SESSION_ATTENDANCE',
  SESSION_QUOTATION: 'SESSION_QUOTATION',
  SIGNATURE_SHEET: 'SIGNATURE_SHEET',
  SUPPORT_GUIDE: 'SUPPORT_GUIDE',
  TRAINER_FEEDBACK: 'TRAINER_FEEDBACK',
  TRAINING_CERTIFICATE: 'TRAINING_CERTIFICATE',
  TRAINING_CONTENT: 'TRAINING_CONTENT',
  TRAININGS_CATALOG: 'TRAININGS_CATALOG',
  TRAININGS_CATALOG_CAPI: 'TRAININGS_CATALOG_CAPI',
  TRAININGS_CATALOG_OH: 'TRAININGS_CATALOG_OH',
  QUALIOPI_CERTIFICATE: 'QUALIOPI_CERTIFICATE'
};

/**
 * Document visibilities
 * @readonly
 * @enum {string}
 */
export const documentVisibility = {
  ADMIN: 'ADMIN',
  GUEST: 'GUEST',
  OWNER: 'OWNER',
  PARTICIPANT: 'PARTICIPANT',
  SESSION_CLOSED: 'SESSION_CLOSED',
  SESSION_STARTED: 'SESSION_STARTED',
  TRAINER: 'TRAINER',
};

/**
 * Notification scopes
 * @readonly
 * @enum {string}
 */
export const notificationScope = {
  ADMIN: 'ADMIN',
  USER: 'USER',
};

/**
 * Notification types
 * @readonly
 * @enum {string}
 */
export const notificationType = {
  MISSING_AGREEMENT_SIGNATURE: 'MISSING_AGREEMENT_SIGNATURE',
  MISSING_PARTICIPANTS: 'MISSING_PARTICIPANTS',
  PAYMENT_PENDING: 'PAYMENT_PENDING',
  PENDING_SESSION_QUESTIONNAIRE: 'PENDING_SESSION_QUESTIONNAIRE',
  PREREQUISITES_BYPASS_ACCEPTED: 'PREREQUISITES_BYPASS_ACCEPTED',
  PREREQUISITES_BYPASS_REFUSED: 'PREREQUISITES_BYPASS_REFUSED',
  PREREQUISITES_BYPASS_REQUESTED: 'PREREQUISITES_BYPASS_REQUESTED',
  REGISTER_BY_STAFF: 'REGISTER_BY_STAFF',
  REGISTER_IN_WAITING_LIST: 'REGISTER_IN_WAITING_LIST',
  REGISTERED_FROM_WAITING_LIST: 'REGISTERED_FROM_WAITING_LIST',
  REGISTRATION_CLOSED: 'REGISTRATION_CLOSED',
  SESSION_END: 'SESSION_END',
  SESSION_NEED_TO_BE_CLOSED: 'SESSION_NEED_TO_BE_CLOSED',
  SESSION_START: 'SESSION_START',
  SIGNATURE_PENDING: 'SIGNATURE_PENDING',
  UNREGISTER_BY_PARTICIPANT: 'UNREGISTER_BY_PARTICIPANT',
  UNREGISTER_BY_STAFF: 'UNREGISTER_BY_STAFF',
  UNREGISTER_FOR_PAYMENT_DEFAULT: 'UNREGISTER_FOR_PAYMENT_DEFAULT',
};

/**
 * Payment statuses
 * @readonly
 * @enum {string}
 */
export const paymentStatus = {
  FREE: 'FREE',
  PENDING: 'PENDING',
  PAYED: 'PAYED',
};

/**
 * Session Participant waiting list statuses keys
 * @readonly
 * @enum {string}
 */
export const waitingListStatus = {
  WAITING_FOR_PLACE: 'WAITING_FOR_PLACE',
  CANCELED_BY_AGENT: 'CANCELED_BY_AGENT',
  CANCELED_BY_ADMIN: 'CANCELED_BY_ADMIN',
  REGISTERED: 'REGISTERED',
};

/**
 * Session Participant waiting list statuses text
 * @readonly
 * @enum {string}
 */
export const waitingListStatusText = {
  WAITING_FOR_PLACE: "En attente d'une place",
  CANCELED_BY_AGENT: 'Annulé',
  CANCELED_BY_ADMIN: 'Annulé',
  REGISTERED: 'Inscrit',
};

/**
 * Questionnaire codes
 * @readonly
 * @enum {string}
 */
export const questionnaireCode = {
  ATTEMPT_1: 'ATTEMPT_1',
  ATTEMPT_2: 'ATTEMPT_2',
  POSITIONING: 'POSITIONING',
  SATISFACTION: 'SATISFACTION',
};

/**
 * Questionnaire statuses
 * @readonly
 * @enum {string}
 */
export const questionnaireStatus = {
  NOT_STARTED: 'NOT_STARTED',
  ON_GOING: 'ON_GOING',
  SUCCESSFUL: 'SUCCESSFUL',
  FAILED: 'FAILED',
  UNKNOWN: 'UNKNOWN',
};

/**
 * Question Types
 * @readonly
 * @enum {string}
 */
export const questionType = {
  LIKERT_AGREEMENT: 'LIKERT_AGREEMENT',
  LIKERT_SATISFACTION: 'LIKERT_SATISFACTION',
  MARK_10: 'MARK_10',
  MARK_20: 'MARK_20',
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
  NUMERIC: 'NUMERIC',
  SINGLE_CHOICE: 'SINGLE_CHOICE',
  TEXT: 'TEXT',
  TRUE_FALSE: 'TRUE_FALSE',
  YES_NO: 'YES_NO',
};

/**
 * Session statuses
 * @readonly
 * @enum {string}
 */
export const sessionFormat = {
  ON_SITE: 'ON_SITE',
  REMOTE: 'REMOTE',
  MIXED: 'MIXED',
};

/**
 * Session statuses
 * @readonly
 * @enum {string}
 */
export const sessionStatus = {
  NON_PUBLISHED: 'NON_PUBLISHED',
  PUBLISHED: 'PUBLISHED',
  REGISTRATION_CLOSED: 'REGISTRATION_CLOSED',
  ON_GOING: 'ON_GOING',
  WAITING_VALIDATION: 'WAITING_VALIDATION',
  PROCESSED: 'PROCESSED',
  CLOSED: 'CLOSED',
  CANCELED: 'CANCELED',
};

/**
 * Signature statuses
 * @readonly
 * @enum {string}
 */
export const signatureStatus = {
  READY: 'ready',
  EXPIRED: 'expired',
  CANCELED: 'canceled',
  FAILED: 'failed',
  COMPLETED: 'completed',
};

/**
 * User types
 * @readonly
 * @enum {string}
 */
export const userType = {
  GUEST: 'GUEST',
  PARTICIPANT: 'PARTICIPANT',
  TRAINER: 'TRAINER',
  ADMIN: 'ADMIN',
};

/**
 * Invoice types
 * @readonly
 * @enum {string}
 */
export const invoiceType = {
  CREDIT: 'CREDIT',
  DEBIT: 'DEBIT',
  ADJUSTMENT: 'ADJUSTMENT',
  PENALTY: 'PENALTY',
};

/**
 * UI Tabs title of session page
 * @readonly
 * @enum {string}
 */
export const uiTabsTitles = {
  PARTS: 'Parties',
  PARTICIPANTS: 'Participants',
  QCM: 'Enquête & QCM',
  DOCS: 'Documents',
};

/**
 * Number of months after which the agent is considered "old agent"
 * and must pay for his training normally
 * @readonly
 * @enum {number}
 */
export const nbMonthsRequiredAgentSeniority = 18;
